<template>
  <div id="predict-image-classification">
    <div class="page-title">
      <span class="name">Classification</span>
    </div>

    <Panel>
      <div class="columns">
        <div class="column">
          <ImageCarousel v-if="ready" :focusedIndex="focusedIndex" :items="images" v-on:indexChanged="indexChanged"></ImageCarousel>
        </div>
        <div class="column">
          <div v-if="this.focusedIsCurrentlyClassifying">
            ...loading
          </div>
          <div class="prediction-row" v-for="prediction of this.highest5PredictionsOfFocused">
            <div class="gray-text" style="white-space: nowrap">{{ $t(`classification.categories.${prediction.cat}`)}}</div>
            <div style="flex-grow: 1; text-align: center; height: 40px">*Bars here*</div>
            <div class="gray-text">{{toFormattedPercent(prediction['%']).toFixed(1)}}%</div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
  import Vue from 'vue';
  import ImageCarousel from '@/components/tools/ImageCarousel.vue';
  import { Core } from '@/core/Core';

  export default {
    name: 'imageClassification',

    components: { ImageCarousel },

    data() {
      return {
        ready: false,
        images: [{
          id: null,
          url: "",
          classification: [{
            "%": 0.00,
            cat: "sushi"
          }]
        }],
        currentlyClassifying: [],
        focusedIndex: null,
      }
    },

    mounted() {
      this.$store.commit("showSpinner", true);
      Core.request("GET", `/api/inventory/${this.$route.query.inventory}/images`, { augment: 'training'})
        .then(response => {
          this.images = response;
          this.focusedIndex = response.length > 0 ? 0 : null;
          this.ready = true
        })
        .catch(e => {
          console.log("Error while fetching inventory's images", e);
        })
        .finally(() => {
          this.$store.commit("showSpinner", false);
        });
    },
    methods: {
      toFormattedPercent(percent) {
        return percent * 100
      },
      isCurrentlyClassifying(id) {
        return this.currentlyClassifying.indexOf(id) !== -1
      },
      reclassify(imageIndex) {
        let imageId = this.images[imageIndex].id;
        this.currentlyClassifying.push(imageId);
        Core.request("GET", `/api/images/${imageId}/classify`)
          .then(response => {
            this.currentlyClassifying = this.currentlyClassifying.filter(x => x !== imageId);
            this.$set(this.images, imageIndex, response);
          })
          .catch(e => {
            console.log("Error while fetching inventory's images", e);
          });
      },
      indexChanged(index) {
        this.focusedIndex = index;
      }
    },
    computed: {
      focusedItem() {
        return this.focusedIndex !== null ? this.images[this.focusedIndex] : null;
      },
      highest5PredictionsOfFocused() {
        return this.focusedItem ? this.focusedItem.classification.sort((a, b) => a['%'] < b['%'] ? 1 : -1).slice(0, 5) : []
      },
      focusedIsCurrentlyClassifying() {
        return this.focusedItem && this.isCurrentlyClassifying(this.focusedItem.id)
      }
    },
    watch: {
      focusedIndex: function (newFocusedIndex) {
        if (newFocusedIndex !== null && this.images[newFocusedIndex].classification.length === 0 && !this.isCurrentlyClassifying(this.images[newFocusedIndex].id)) {
          this.reclassify(newFocusedIndex)
        }
      }
    },
  };

</script>


<style lang="scss" scoped>
  .title {
    color: #ed2937;
  }

  .prediction-row {
    display: flex;
    .filled {
      height: 40px;
      background-color: #fc6650;
    }
    .unfilled {
      height: 40px;
      background-color: #fcbfb6;
    }
  }
  .gray-text {
    width: 37px;
    height: 11px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #808080;
  }
  .image-preview {
    display: flex;
    height: 260px;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
</style>